module.exports = __webpack_public_path__ + "static/media/main idea.4dd5674c.mp3";